import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d40a5486"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "correcciones-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "p3 p-mt-1 text-light-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check_fill = _resolveComponent("check-fill")!
  const _component_icon = _resolveComponent("icon")!
  const _component_circle_badge = _resolveComponent("circle-badge")!
  const _component_tag = _resolveComponent("tag")!
  const _component_thumb_up = _resolveComponent("thumb-up")!
  const _component_thumb_down = _resolveComponent("thumb-down")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, null, {
    default: _withCtx(() => [
      _createElementVNode("dl", _hoisted_1, [
        (_ctx.porCorregir === 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.copies.upToDate), 1),
              _createElementVNode("dd", null, [
                _createVNode(_component_circle_badge, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon, {
                      fillColor: 'var(--white)',
                      strokeColor: 'transparent'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_check_fill)
                      ]),
                      _: 1
                    }, 8, ["fillColor"])
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.porCorregir) + " " + _toDisplayString(_ctx.copies.deliversToEvaluate), 1),
              _createElementVNode("dd", null, [
                _createVNode(_component_tag, { class: "bg-gray-1 p-px-3 regular" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.copies.new), 1)
                  ]),
                  _: 1
                })
              ])
            ], 64)),
        _hoisted_2,
        (!_ctx.fueraDeTiempo)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.copies.allEvaluationsInTime), 1),
              _createElementVNode("dd", null, [
                _createVNode(_component_circle_badge, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_thumb_up)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("dt", null, [
                _createTextVNode(_toDisplayString(_ctx.copies.evaluationsOutOfTime) + " ", 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.copies.timeToEvaluate), 1)
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_circle_badge, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_thumb_down)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ], 64))
      ])
    ]),
    _: 1
  }))
}